const req = require.context('./', true, /^(?:[\w]+|.*\.js)$/);

const modules = req.keys().map(req);

module.exports = modules.reduce((result, current) => {
	const keys = Object.keys(current);
	return keys.reduce((r, key) => {
		r[key] = current[key];
		return r;
	}, result);
}, {});
